import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Skeleton,
    Stack,
} from '@mui/material';

const UserTableSkeleton: React.FC = () => {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell padding='checkbox'>
                        <Skeleton variant="circular" width={24} height={24} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={60} height={20} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={80} height={20} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={60} height={20} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={100} height={20} />
                    </TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {[1, 2, 3, 4].map((index) => (
                    <TableRow
                        key={index}
                        sx={{
                            backgroundColor: '#FAFAFA',
                            borderRadius: '12px',
                            boxShadow: '0px 0px 1px rgba(0,0,0,0.08)',
                            '& td': { borderBottom: 'none' },
                        }}
                    >
                        <TableCell padding='checkbox'>
                            <Skeleton variant="circular" width={24} height={24} />
                        </TableCell>
                        <TableCell>
                            <Skeleton 
                                variant="rounded" 
                                width={80} 
                                height={30} 
                                sx={{ borderRadius: '15px' }}
                            />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={100} height={20} />
                        </TableCell>
                        <TableCell>
                            <Stack spacing={0.5}>
                                <Skeleton 
                                    variant="rounded" 
                                    width={120} 
                                    height={24} 
                                    sx={{ borderRadius: '13px' }}
                                />
                                <Skeleton 
                                    variant="rounded" 
                                    width={140} 
                                    height={24} 
                                    sx={{ borderRadius: '13px' }}
                                />
                            </Stack>
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={80} height={16} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={90} height={16} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={40} height={20} />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default UserTableSkeleton; 